import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    Ref,
} from '@vue/composition-api';

import OfferEvent from '@core/models/offer/OfferEvent';
import { VirtualTournament } from '@sportOfferFederation/competitions/types';
import { SportOfferDataStore } from '@store/modules/data/sportOffer';

export function useHotTournamentLiveEvents(hotTournament: Ref<VirtualTournament>) {
    const sportOfferStore = useVuexStore<SportOfferDataStore>('data/sportOffer');
    const events = sportOfferStore.getter('events');

    const tournamentIds = computed(() => new Set(hotTournament.value.childrenIds));

    const liveEvents = computed(() => events.value.filter(
        (event: OfferEvent) => tournamentIds.value.has(event.tournamentId) && event.isOngoing() && !event.isFinished(),
    ));

    return {
        liveEvents,
    };
}
